import React from 'react';

const RatingsBreakIcon = ({color,size}) => {	
    return (
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" id="link-simple-break" width={size} height={size}>
                <rect width="256" height="256" fill="none"></rect>
                <path fill="none" stroke="#1e2227" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" d="M144.96473 178.9102l-28.28427 28.28427a48 48 0 0 1-67.88225-67.88225L77.08248 111.028M178.91069 144.96424L207.195 116.68a48 48 0 0 0-67.88225-67.88225L111.02844 77.082"></path>
            </svg>
        </span>
    );
}

RatingsBreakIcon.defaultProps = {
    color:'#ffad46',
    size:'24',
}
export default RatingsBreakIcon;